(() => {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};

    /**
     * The Campaign Template Communication model for Yumbi Campaigns
     * @constructor
     */
    class ExclusionRules {
        /**
         * The send flag for SMS
         * @type {boolean}
         */
        CanSMS = false;

        /**
         * The send flag for Push notification
         * @type {boolean}
         */
        CanPush = false;

        /**
         * The send flag for Email
         * @type {boolean}
         */
        CanEmail = false;
    }
    window.Dashboard.Models.ExclusionRules = ExclusionRules;
})();
